<div class="grade-matrix-wrapper">
    <div class="grade-header">
        <h4>{{ 'SETTING_PAGE.CDMS_SETTINGS.GRADE_MATRIX' | transloco }}</h4>
        <button class="btn primary-ebtn" (click)="addGrade()">
            <mat-icon matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}">add</mat-icon>
        </button>
    </div>

    <div class="grade-content">
        <table class="grade-matrix-table">
            <thead>
                <tr>
                    <th>{{ 'SETTING_PAGE.CDMS_SETTINGS.GRADE_LEVEL' | transloco }}</th>
                    <th>{{ 'SETTING_PAGE.CDMS_SETTINGS.MIN_SCORE' | transloco }}</th>
                    <th>{{ 'SETTING_PAGE.CDMS_SETTINGS.MAX_SCORE' | transloco }}</th>
                    <th>{{ 'SETTING_PAGE.CDMS_SETTINGS.STATUS' | transloco }}</th>
                    <th>{{ 'SETTING_PAGE.CDMS_SETTINGS.ACTIONS' | transloco }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of gradeMatrixData">
                    <td>{{ element.gradeLevel }}</td>
                    <td>{{ element.minScore }}</td>
                    <td>{{ element.maxScore }}</td>
                    <td>{{ element.status }}</td>
                    <td>
                        <button class="btn-icon" (click)="editGrade(element)" matTooltip="Edit">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button class="btn-icon delete" (click)="deleteGrade(element)" matTooltip="Delete">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
